import {
  GET_TOKEN_ERROR,
  GET_UNIQUE_PASS_RECOVERY_INFO_ERROR,
  GET_UNIQUE_PASS_RECOVERY_INFO_SUCCESS,
  GET_USER_INFO_ERROR,
  GET_USER_INFO_SUCCESS
} from './UniquePassAuth.actions'

const uniquePassAuthState = {
  loading: true,
  error: false,
  isRecoveryAdmin: false
}

/**
 * The unique pass auth's reducer.
 */
const uniquePassAuthReducer = (state = uniquePassAuthState, { payload, type }) => {
  switch (type) {
    case GET_TOKEN_ERROR:
    case GET_USER_INFO_ERROR: {
      return { ...state, loading: false, error: true }
    }
    case GET_USER_INFO_SUCCESS: {
      return { ...state, loading: false }
    }
    case GET_UNIQUE_PASS_RECOVERY_INFO_ERROR: {
      return { ...state, loading: false, error: true }
    }
    case GET_UNIQUE_PASS_RECOVERY_INFO_SUCCESS: {
      return { ...state, loading: false, isRecoveryAdmin: payload.backup.isRecoveryAdmin }
    }
    default: {
      return state
    }
  }
}

export default uniquePassAuthReducer
